import TitleDescription from '@/common/components/base/typography/TitleDescription';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';
import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import { css } from 'styled-system/css';
import { getCulpritCustomerDocumentImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerDocumentImages/getCulpritCustomerDocumentImagesQueryOptions';
import { ImagesListName } from '@/common/utils/ImagesListName';
export default () => {
  return (
    <MainLayout title="مقصر / تصاویر" header="titleHeader" hasBottomPadding>
      <CustomerDocumentsImages />
    </MainLayout>
  );
};

const CustomerDocumentsImages = () => {
  const { id } = useParams();

  const { data: documentImagesList, isRefetching: getListLoading } = useQuery(
    getCulpritCustomerDocumentImagesQueryOptions({
      id: Number(id),
    }),
  );
  if (getListLoading) return <LoadingPage />;
  return (
    <Box pt="1.5rem">
      <TitleDescription>تصاویر مدارک</TitleDescription>
      {documentImagesList?.length ? (
        <Flex
          gap="1rem"
          maxWidth="maxContainer"
          margin="auto"
          mt="1.5rem"
          className={grid({ columns: 2 })}
        >
          {documentImagesList?.map((image, index) => (
            <ImageCard
              key={image.id}
              imageData={{
                name: ImagesListName({
                  titleType: 'document',
                  index,
                }),
                src: image.image,
              }}
              extension={{
                type: 'download',
              }}
            />
          ))}
        </Flex>
      ) : (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      )}
    </Box>
  );
};
